"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _HelpBlockContainer = _interopRequireDefault(require("../../../internal/HelpBlockContainer"));

var _Label = _interopRequireDefault(require("../../../internal/Label"));

var _prefix = _interopRequireDefault(require("../../../prefix"));

var _Dropdown = _interopRequireDefault(require("../../../Dropdown"));

var _Button = _interopRequireDefault(require("./../../../Button"));

var InputWrapper = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(InputWrapper, _React$Component);

  function InputWrapper() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, InputWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(InputWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.flattenChildren = function (children) {
      var addonsArray = [];
      children.forEach(function (child) {
        if (Array.isArray(child)) {
          addonsArray.push.apply(addonsArray, (0, _toConsumableArray2["default"])(_this.flattenChildren(child)));
        } else {
          if (!child) return;

          var wrappedChild = _this.wrapChild(child);

          addonsArray.push(wrappedChild);
        }
      });
      return addonsArray;
    };

    _this.setChildren = function (childNodes) {
      if (!childNodes) {
        return;
      } else if (!Array.isArray(childNodes)) {
        return _this.wrapChild(childNodes);
      } else {
        return _this.flattenChildren(childNodes);
      }
    };

    _this.wrapChild = function (addon) {
      var type = addon.type;

      if (type === _Button["default"] || type === _Dropdown["default"]) {
        // If child is our own Dropdown or Button we wrap with "input-group-btn" class
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "".concat(_prefix["default"], "input-group-btn")
        }, addon);
      }

      return addon;
    };

    return _this;
  }

  (0, _createClass2["default"])(InputWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          appendChild = _this$props.appendChild,
          className = _this$props.className,
          disabled = _this$props.disabled,
          displayLabel = _this$props.displayLabel,
          formControl = _this$props.formControl,
          htmlId = _this$props.htmlId,
          inputPrefix = _this$props.inputPrefix,
          inputSuffix = _this$props.inputSuffix,
          label = _this$props.label,
          layout = _this$props.layout,
          prependChild = _this$props.prependChild,
          required = _this$props.required,
          validationState = _this$props.validationState;
      var prependedChildren = prependChild && this.setChildren(prependChild);
      var appendedChildren = appendChild && this.setChildren(appendChild);
      var wrapComponentWithFormGroup = prependedChildren || appendedChildren || inputPrefix || inputSuffix;
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "".concat(htmlId, "-inputWrapper"),
        className: (0, _classnames["default"])(["".concat(_prefix["default"], "form-group"), "input-wrapper", className, "".concat(htmlId, "__formGroup"), layout === "horizontal" && "input-side-by-side", validationState.type === "error" && "has-error"])
      }, displayLabel && /*#__PURE__*/_react["default"].createElement(_Label["default"], {
        className: className,
        htmlId: "".concat(htmlId, "-label"),
        required: required
      }, label), wrapComponentWithFormGroup ? /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])(["".concat(_prefix["default"], "input-group"), inputPrefix && "input-group--prefix", inputSuffix && "input-group--suffix"])
      }, prependedChildren, inputPrefix && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(["".concat(_prefix["default"], "input-group-addon"), "addon-prefix"]),
        disabled: disabled,
        id: "".concat(htmlId, "-prefix-addon")
      }, inputPrefix), formControl, inputSuffix && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(["".concat(_prefix["default"], "input-group-addon"), "addon-suffix"]),
        disabled: disabled,
        id: "".concat(htmlId, "-suffix-addon")
      }, inputSuffix), appendedChildren) : formControl, validationState.type && /*#__PURE__*/_react["default"].createElement(_HelpBlockContainer["default"], {
        message: validationState.msg,
        status: validationState.type
      }));
    }
  }]);
  return InputWrapper;
}(_react["default"].Component);

InputWrapper.defaultProps = {
  disabled: false,
  displayLabel: true,
  layout: "vertical",
  required: false,
  validationState: {
    msg: null,
    type: null
  }
};
var _default = InputWrapper;
exports["default"] = _default;